import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, errMessage, errFields } from "@/lib/api";
import { FieldError } from "@/components/common";

const FIELDS = [["first_name", "Prénom", "given-name"], ["last_name", "Nom", "family-name"], ["phone", "Téléphone", "tel"]];

// Shared by "Mon profil" (url /auth/profile) and the workplace admin (url /admin/users/:id/profile). E-mail stays fixed.
export const ProfileForm = ({ initial, url, email, onSaved, testPrefix = "profile" }) => {
  const [form, setForm] = useState({ first_name: initial.first_name || "", last_name: initial.last_name || "", phone: initial.phone || "" });
  const [errors, setErrors] = useState({});
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    const local = {};
    if (!form.first_name.trim()) local.first_name = "Indiquez le prénom.";
    if (!form.last_name.trim()) local.last_name = "Indiquez le nom de famille.";
    if (Object.keys(local).length) return setErrors(local);
    setBusy(true);
    setErrors({});
    try {
      await api.put(url, form);
      toast.success("Informations enregistrées.");
      onSaved?.();
    } catch (err) { setErrors(errFields(err) || {}); toast.error(errMessage(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={save} className="grid gap-4 sm:grid-cols-2" data-testid={`${testPrefix}-form`}>
      {FIELDS.map(([k, label, auto]) => (
        <div key={k}>
          <label htmlFor={`${testPrefix}-${k}`} className="text-sm font-semibold">{label}{k === "phone" ? " (facultatif)" : ""}</label>
          <Input id={`${testPrefix}-${k}`} data-testid={`${testPrefix}-${k}-input`} autoComplete={auto} type={k === "phone" ? "tel" : "text"}
            value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="mt-1.5 h-11 text-base" />
          <FieldError error={errors[k]} testId={`${testPrefix}-${k}-error`} />
        </div>
      ))}
      <div>
        <label className="text-sm font-semibold">E-mail (identifiant, non modifiable)</label>
        <Input data-testid={`${testPrefix}-email-input`} value={email} disabled className="mt-1.5 h-11 text-base" />
      </div>
      <div className="sm:col-span-2">
        <Button type="submit" data-testid={`${testPrefix}-save`} disabled={busy} className="h-11">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Enregistrer</Button>
      </div>
    </form>
  );
};
